import 'array-flat-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { ColorModeScript, Theme } from '@workshop/ui';

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    <ColorModeScript initialColorMode={Theme.config.initialColorMode} />
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
